export const getPublishErrorMessage = (error: unknown): string => {
    // Default error message
    const defaultErrorMessage = 'Oops something is wrong. Please refresh and try again'

    // Check if it's the specific 400 error for survey name already taken
    if (
        error &&
        typeof error === 'object' &&
        'status' in error &&
        error.status === 400 &&
        'message' in error &&
        error.message === 'Survey name already taken'
    ) {
        return 'Error: This survey name is already taken. Please fix this and try again'
    }

    // Fall back to default message for all other errors
    return defaultErrorMessage
}

export const getPublishSummaryMessage = (isSurveyPublishing: boolean): string => {
    const defaultSummaryMessage =
        '  Once published, the survey will accept responses. A link will be generated for you to share with respondents.'

    if (isSurveyPublishing) {
        return 'Generating a link for your Survey...'
    }

    return defaultSummaryMessage
}
